module.exports = __webpack_public_path__ + "img/nzs_zufriedenheit_allein_reicht_nicht.8b8c8ec7.png";